import useFlag from 'hooks/useFlag'

type ReportPermissionConfig = {
  rbac: string
  legacy: string
  rbacAction?: 'access' | 'manage'
  legacyAction?: 'access' | 'manage'
}

/**
 * Returns the correct resource and action for a report page guard,
 * switching between RBAC and legacy permission subjects based on the
 * `role-based-access-control` feature flag.
 *
 * The hook itself is a simple flag-gated switch — the actual permission
 * differences are expressed in each callsite's config. Most reports use
 * the default action ('access'), but individual reports can override via
 * rbacAction/legacyAction when their legacy or RBAC check requires 'manage'.
 */
export const useReportPermission = (config: ReportPermissionConfig) => {
  const rbacEnabled = useFlag('role-based-access-control', false)
  return {
    resource: rbacEnabled ? config.rbac : config.legacy,
    action: rbacEnabled
      ? config.rbacAction ?? 'access'
      : config.legacyAction ?? 'access',
  }
}
